export const EyeIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M6.34314 6.65687L1 12L6.34315 17.3432C9.46734 20.4674 14.5327 20.4673 17.6569 17.3432L23 12L17.6569 6.65686C14.5327 3.53267 9.46734 3.53267 6.34314 6.65687Z" />
      <path d="M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3432 10.3431 9.00001 12 9.00001C13.6569 9.00001 15 10.3432 15 12Z" />
    </svg>
  );
};
